export const colors = {
  primary: "#510099",
  lightPrimary: "#340062",
  lighterPrimary: '#E2CCF5',
  veryLightPrimary: "#E1E2FF",
  darkPrimary: "#29004D",
  white: "#fff",
  black: "#000",
  orange: "#F56423",
  darkAsh: "#727272",
  lightAsh: "#D9D9D9",
  darkAshLight: "#3B3B3B",
  darkGreen: "#008750",
  inputAsh: "#979797",
  progressBarAsh: "#EFEFEF",
  red: '#FF3A00',
  lightRed: '#FFE4DC',
  darkPurple: '#39006B',
  darkerPrimary: "#39006B"
};


/**
 * @param sizes: xxsm: 12, xsm: 14, sm:16, md: 18
 */
export const fontSizes = {
  xxsm: 12,
  xsm: 14,
  sm: 16,
  md: 18,
  lg: 20,
  xlg: 30,
  xxlg: 40,
};

export const fontWeight = {
  bold: 700,
  medium: 600,
  regular: 400,
  light: 300,
};

export const fonttypes = {
  sg_bold: "SpaceGrotesk Bold",
  sg_light: "SpaceGrotesk Light",
  sg_medium: "SpaceGrotesk Medium",
  sg_regular: "SpaceGrotesk Regular",
  sg_semibold: "SpaceGrotesk SemiBold",
  circular_bold: 'Circular Std Bold'
};
